module.exports = __webpack_public_path__ + "producr-dried fresh-grass-13.jpg?31adecd59ba8c57f0a72a58e93030735";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-13.jpg
// module id = 71
// module chunks = 0